export default "__VITE_ASSET__64c4c04d__"